import { Action } from "./action";
import { State } from "./state";

export const reducer = (state: State, action: Action): State => {
	switch (action.type) {
		case "bufferedChildren":
			return {
				...state,
				bufferedChildren: action.payload,
			};
		case "height":
			return {
				...state,
				height: action.payload,
			};
	}
};
